import {Route} from "vue-router";


interface NextQuery {
    path: string | null;
    query: {};
}

export default class RoutingBehavior {
    private to: Route;


    private query: NextQuery = {
        path: null,
        query: {},
    }

    private authPageRoute = [
        '/logout',
        '/confirm',
        '/sign-in',
        '/sign-up',
        '/change',
        '/forgot-password',
    ];

    private registerFlowRoute = [
        '/sign-up', '/register', '/register/call', '/register/credit'
    ];

    /**
     * @param to
     */
    constructor(to: Route) {
        this.to = to;
    }

    private isAuthPageRouting() {
        return this.authPageRoute.includes(this.to.path);
    }

    private isRegisterFlowRouting() {
        return this.registerFlowRoute.includes(this.to.path);
    }

    /**
     * ログアウト時の挙動
     * @param token
     */
    doLogout(token = null) {
        if (this.to.path === '/logout') {
            return true;
        }
        if (token !== null) {
            return false;
        }
        if (!this.isAuthPageRouting()) {
            this.query = {
                path: '/logout', query: {redirect: this.to.fullPath}
            }
        }
        return true;
    }

    doAuthenticated(){
        if (this.isRegisterFlowRouting()) {
            this.query.path = '/';
        }
    }

    doCreditPage() {
        if (this.to.path === '/register/credit') {
            return;
        }
        this.query.path = '/register/credit';
    }

    doRegisterCallPage() {
        if (this.to.path === '/register/call') {
            return;
        }
        this.query.path = '/register/call';
    }

    doIf412Initialized() {
        if (this.to.path === '/register' || this.isPublic()) {
            return;
        }
        this.query = ({path: '/register', query: {redirect: this.to.fullPath}});
    }

    isPublic() {
        return this.to.matched.some(record => record.meta.isPublic);
    }


    getNextQuery() {
        if (this.query.path === null) {
            return {};
        }
        return Object(this.query);
    }
}